import React,  { useEffect, useState } from 'react';
import { appStage } from '../../redux/helper/upload-config';
import { userService } from '../../service/user.service';

function Footer() {
    const [version, setVersion] = useState({});
    const appVersion = async () => {
        let stage = ''
        if (window.location.href.includes('dev')){
            stage='develop'
        }
        else if(window.location.href.includes('staging')){
            stage='staging'
        }
        else if(window.location.href.includes('beta')){
            stage='beta'
        }
        else {
            stage = 'master'
        }
        let result = await userService.appVersion({
            stage: stage,
        });
        setVersion(result.data.data[0].distributor_web_application);
    };
    useEffect(() => {
        appVersion();
    }, []);
    return (
        <div className="py-2 text-center fixed w-full bottom-0 bg-white" style={{backgroundColor:'white',zIndex:'50'}}>
            <p className="text-xs3 font-semibold text-[#ED1C24]">
                ©
                {'version : '}
                {version.latest_version}
                {', '}
                2022 Ador Welding Limited</p>
        </div>
    );
}
export default Footer;
